module.exports = "a613540ad1a0743b7583b955adab9821.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/temple-balcony-L.png
// module id = 45
// module chunks = 0